import React from 'react';
import { connect } from 'react-redux';
import configuration from '../../constants/Configuration';
import Draggable from 'react-draggable';
import { setMediaFilesDataProvider } from '../../actions/AccordionActions';
import { showAudioAlert, showRecorder } from '../../actions/MenuActions';
import { changeSlideDuration, setSlideSound } from '../../actions/CurrentSlideActions';
import { changeSlideProperty } from '../../actions/ProductionActions';
import locales from '../../locales/LocalesManager';
import storeManager from '../../store/StoreManager';
import apiServiceUtils from '../utils/ApiServiceUtils';
import mouseUtils from '../utils/MouseUtils';
import audioRecorder from '../utils/AudioRecorder';
import durationUtils from '../utils/DurationUtils';
import recordingUtils from '../utils/RecordingUtils';
import reactNativeBridge from '../utils/ReactNativeBridge';
import platformDetection from '../utils/PlatformDetection';
import recordedSoundUploadingUtils from '../utils/RecordedSoundUploadingUtils';
import appParameters from '../utils/AppParameters';
import playController from '../utils/PlayController';
import audioVolumeUtils from '../utils/AudioVolumeUtils';
import saveManager from '../utils/SaveManager';
import populateMediaFilesUtils from '../utils/PopulateMediaFilesUtils';
import fineUploader from '../utils/FineUploader';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import videoUtils from '../utils/VideoUtils';
import audioConverter from '../audioEditor/utils/AudioConverter';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import apiService from '../../services/ApiService';

const RecorderPopupContent = React.createClass({
    getInitialState() {
        const width = 460;
        const height = 195;

        return {
            isCancelOver: false,
            isSaveOver: false,
            isStartOver: false,
            isPlayOver: false,
            isPlaying: false,
            currentX: (this.props.windowWidth - width) / 2,
            currentY: (this.props.windowHeight - height) / 2,
            currentState: 0 // 0 - start, 1 - stop, 2 - encoding, 3 - ready to use, 4 - storing, 5 - saving error
        };
    },
    componentDidUpdate(prevProps){
        if (platformDetection.isIOS())
            return;

        if(!prevProps.showRecorder && this.props.showRecorder) {
            const firstEl = document.getElementById("recordingFirstFocusableElement");
            if (firstEl) {
                firstEl.focus();
            }
        }
    },
    onCancelMouseIn() {
        this.setState({
            isCancelOver: true
        });
    },
    onCancelMouseOut() {
        this.setState({
            isCancelOver: false
        });
    },
    onPlayMouseIn() {
        this.setState({
            isPlayOver: true
        });
    },
    onPlayMouseOut() {
        this.setState({
            isPlayOver: false
        });
    },
    onSaveMouseIn() {
        this.setState({
            isSaveOver: true
        });
    },
    onSaveMouseOut() {
        this.setState({
            isSaveOver: false
        });
    },
    onStartMouseIn() {
        this.setState({
            isStartOver: true
        });
    },
    onStartMouseOut() {
        this.setState({
            isStartOver: false
        });
    },
    getDispatch() {
        return storeManager.getStore().dispatch;
    },
    convertTimeToStringFormat(time) {
        time = time / 1000; //convert milliseconds to seconds
        time = parseFloat(time.toFixed(3));

        var text = '';
        var seconds = Math.floor(time);
        var miliseconds = Math.floor((time - seconds) * 1000);
        var minutes = Math.floor(seconds / 60);
        seconds = seconds - minutes * 60;

        if (minutes < 10)
            text = text + '0' + minutes + ':';
        else
            text = text + minutes + ':';

        if (seconds < 10)
            text = text + '0' + seconds + ':';
        else
            text = text + seconds + ':';

        if (miliseconds < 10)
            text = text + '00' + miliseconds;
        else
        if (miliseconds < 100)
            text = text + '0' + miliseconds;
        else
            text = text + miliseconds;

        return text;
    },
    close() {
        if (this.state.recordingTimer)
            clearInterval(this.state.recordingTimer);

        this.setState({
            currentState: 0,
            blob: undefined
        });

        this.clearSoundElement();
        this.getDispatch()(showRecorder(false));
    },
    onCancelClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.close();

        if (platformDetection.isIOSApp())
            reactNativeBridge.stopRecording(undefined);
        else
            audioRecorder.stopRecording(undefined);

        recordingUtils.removeRecordingPosition();
        this.stopPlayingSequence();
        durationUtils.clearRecordingDuration();
    },
    /*************************** Play/Pause ********************************/
    onPlayClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (!this.refs.audioElement)
            return;

        if (this.state.isPlaying) {
            this.refs.audioElement.pause();
            this.refs.audioElement.currentTime = 0;
        } else
            this.refs.audioElement.play();


        this.setState({
            isPlaying: !this.state.isPlaying
        });
    },
    onAudioEnded() {
        this.setState({
            isPlaying: false
        });

        if (this.refs.audioElement)
            this.refs.audioElement.currentTime = 0;
    },
    clearSoundElement() {
        this.setState({
            isPlaying: false,
            blob: undefined
        });

        if (!this.refs.audioElement)
            return;

        if (this.state.isPlaying)
            this.refs.audioElement.pause();

        if (this.refs.audioElement.src && this.refs.audioElement.src.length > 0)
            window.URL.revokeObjectURL(this.refs.audioElement.src);

        this.refs.audioElement.currentTime = 0;
        this.refs.audioElement.src = '';
    },
    /*************************** Recording ********************************/
    onStartClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.state.currentState == 0 || this.state.currentState == 3) { // start recording
            if (platformDetection.isIOSApp() == true) {
                if (!reactNativeBridge.isIOSRecorderEnabled)
                    return;

                reactNativeBridge.startRecording();
            } else {
                if (!audioRecorder.isRecordAvailable)
                    return;

                audioRecorder.startRecording();
            }

            playController.getOldScrollPosition();
            durationUtils.startRecording(this.stopRecording);
            recordingUtils.setCurrentRecordingPosition();
            this.startPlayingSequence();

            if (this.state.recordingTimer)
                clearInterval(this.state.recordingTimer);

            var recTimer = setInterval(this.onRecordingTimer, 50);

            if (this.state.currentState == 3)
                this.clearSoundElement();

            this.setState({
                currentState: 1,
                recordingTimer: recTimer,
                startTime: new Date().getTime()
            });
        } else if (this.state.currentState == 1) { // stop recording
            this.stopRecording();
        }
    },
    stopRecording() { // stops the recording flow
        if (platformDetection.isIOSApp() == true) {
            reactNativeBridge.stopRecording(this.endRecording);
        } else {
            audioRecorder.stopRecording(this.endRecording);
        }

        this.stopPlayingSequence();
        durationUtils.clearRecordingDuration();

        if (this.state.recordingTimer)
            clearInterval(this.state.recordingTimer);

        this.setState({
            currentState: 2,
            startEncodingTime: new Date().getTime(),
            duration: this.convertTimeToStringFormat(new Date().getTime() - this.state.startTime),
            realDuration: (new Date().getTime() - this.state.startTime) / 1000
        });
    },
    endRecording(blob) {
        console.log('Recording time = ' + this.state.realDuration + ' ----> Encoding time = ' + (new Date().getTime() - this.state.startEncodingTime) / 1000);

        // should create a new context because something broke the old audio context when call reactNativeBridge.stopRecording()
        if (audioVolumeUtils.useVolumeFunctionality())
            audioVolumeUtils.reset();

        const url = URL.createObjectURL(blob);

        this.setState({
            currentState: 3,
            isPlaying: false,
            blob
        });

        if (this.refs.audioElement)
            this.refs.audioElement.src = url;
    },
    onRecordingTimer() {
        if (this.refs.duration)
            this.refs.duration.textContent = this.convertTimeToStringFormat(new Date().getTime() - this.state.startTime);

        var maxLevel = Math.floor(audioRecorder.getMicrophoneLevel() / 4);

        for (var i=0; i<10; i++) {
            var element = this.refs['level_' + i];

            if (!element)
                continue;

            if (i<=maxLevel)
                element.style.background = '#69ac12';
            else
                element.style.background = '#dfe0d4';
        }
    },
    /**************************** Saving *******************************/
    onSaveClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.setState({
            currentState: 4
        });

        if (configuration.LOAD_LOCAL)
            return;

        var recordingItem = recordingUtils.getCurrentRecordingPosition();
        var title = recordingItem.title;

        populateMediaFilesUtils.stopRefreshTimers();
        recordingUtils.startUploadingTime = new Date().getTime();
        recordedSoundUploadingUtils.startStoring();

        if (this.refs.title && this.refs.title.value && this.refs.title.value != title)
            title = this.refs.title.value;

        if (title && title.indexOf('.mp3') < 1)
            title = title + '.mp3';

        fineUploader.uploadFile(this.state.blob, title, this.uploadComplete);
    },
    uploadComplete(val, title, content) {
        populateMediaFilesUtils.restartRefreshTimers();

        if (content && content.contentItemId > 0) {
            this.dataSaved(content.contentItemId, title);
        } else {
            this.setState({
                currentState: 5
            });
        }
    },
    dataSaved(contentItemId, title) {
        console.log('Storing time is: ' + (new Date().getTime() - recordingUtils.startUploadingTime) / 1000 + ' seconds');

        if (recordedSoundUploadingUtils.refreshTimer != -1)
            clearInterval(recordedSoundUploadingUtils.refreshTimer);

        recordedSoundUploadingUtils.currentContentItemId = contentItemId;
        recordedSoundUploadingUtils.currentTile = title;
        recordedSoundUploadingUtils.refreshTimer = setInterval(this.checkFileStatus, 4 * 1000);
    },
    checkFileStatus() {
        var id = recordedSoundUploadingUtils.currentContentItemId;

        apiService.getSignedContent([id])
            .then(response => {
                var soundUrl = response[id];

                if (soundUrl && (soundUrl.indexOf('creaza-user-audios.s3.eu-west-1.amazonaws') != -1 || soundUrl.indexOf('user-audios.s3.amazonaws') != -1 || soundUrl.indexOf('creaza-stage-upload.s3.amazonaws') != -1 || soundUrl.indexOf('creaza-stage-upload.s3.eu-west-1.amazonaws.com') != -1))
                    this.dataCompleteUploaded();
            });
    },
    dataCompleteUploaded() {
        if (recordedSoundUploadingUtils.refreshTimer != -1)
            clearInterval(recordedSoundUploadingUtils.refreshTimer);

        recordedSoundUploadingUtils.refreshTimer = -1;

        var contentItemId = recordedSoundUploadingUtils.currentContentItemId;
        var title = recordedSoundUploadingUtils.currentTile;

        if (contentItemId > 0) {
            console.log('Complete uploading time is: ' + (new Date().getTime() - recordingUtils.startUploadingTime) / 1000 + ' seconds');

            var newUrl = '/file/ci/' + contentItemId + '/aaa';
            var recordingItem;
            var position;

            if (playController.isAudioEditorAvailable()) {
                recordingItem = recordingUtils.getCurrentRecordingPosition();
                position = recordingItem.position;
                audioEditorUtils.addRecordedSoundToTimeline(newUrl, title, position, this.state.realDuration);
                recordingUtils.removeRecordingPosition();

                if (!playController.isAudioEditorMode())
                    playController.toggleAudioEditorMode(true);
            } else {
                recordingItem = recordingUtils.getRecordingPositionWhenDataSaved(title);

                var sound = {};
                sound.contentItemId = contentItemId;
                sound.href = newUrl;
                sound.title = recordingItem.title;

                position = recordingItem.position;

                if (position != '' && position != storeManager.getState().currentSlide.model.uuid)
                    this.getDispatch()(changeSlideProperty(position, 'sound', sound));
                else
                    this.getDispatch()(setSlideSound(sound));

                this.getDispatch()(showAudioAlert(0, title));
                audioConverter.addSoundDurationToMap(sound.href, this.state.realDuration);

                this.addSlideDuration();
            }

            this.addToMyMediaFiles(contentItemId);

            recordedSoundUploadingUtils.stopStoring();
            saveManager.isContentChanged(true);
            audioEditorUtils.addActionToHistory();
        } else
            recordedSoundUploadingUtils.currentContentItemId = -1;

        this.close();
    },
    addSlideDuration() {
        var duration = this.state.realDuration;

        if (duration > 0 && !playController.isAudioEditorMode() && !videoUtils.isVideoBackground()) {
            duration = parseFloat(duration.toFixed(1));
            this.getDispatch()(changeSlideDuration(duration));
        }

        recordingUtils.removeRecordingPosition();
    },
    addToMyMediaFiles(contentItemId) {
        const state = storeManager.getState();
        const mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;

        if (mediaFilesDataProvider != undefined) {
            this.appendSound(contentItemId);
        } else {
            if (configuration.LOAD_LOCAL == false) {
                apiServiceUtils.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
            }
        }
    },
    appendSound(contentItemId) {
        const state = storeManager.getState();
        const mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;

        if (contentItemId == undefined || mediaFilesDataProvider == undefined)
            return;

        recordedSoundUploadingUtils.currentContentItemId = -1;
        var newDataProvider = {};
        var sounds = mediaFilesDataProvider.soundsDataProvider;
        var storedSound = {};

        storedSound.contentItemId = contentItemId;
        storedSound.href = `/file/ci/${contentItemId}/aaa`;

        var audio = this.refs.recordedAudio;
        var duration = 0;
        var recordingItem = recordingUtils.getCurrentRecordingPosition();

        if (audio) {
            audio.src = storedSound.href;

            setTimeout(function() {
                duration = Math.ceil(audio.duration) * 1000;

                storedSound.duration = durationUtils.transformDuration(duration);
                storedSound.title = recordingItem.title;
                storedSound.isRecordedSound = true;

                sounds.unshift(storedSound);

                newDataProvider.soundsDataProvider = sounds;
                newDataProvider.imagesDataProvider = mediaFilesDataProvider.imagesDataProvider;
                newDataProvider.videosDataProvider = mediaFilesDataProvider.videosDataProvider;

                this.getDispatch()(setMediaFilesDataProvider(newDataProvider));
            }.bind(this), 2000);
        }
    },
    loadMyMediaFiles() {
        apiServiceUtils.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
    },
    parseMediaItems(items) {
        populateMediaFilesUtils.parseMediaItems(items, this.getDispatch());
    },
    getTitles() {
        var titles = {};

        titles.popupTitle = locales.getCaption('popupTitle', 'audioRecorder');//'Sound Recorder';
        titles.record = locales.getCaption('record', 'audioRecorder');//'RECORD';
        titles.stop = locales.getCaption('stop', 'audioRecorder');//'STOP';
        titles.play = locales.getCaption('play', 'audioRecorder');//'Play';
        titles.pause = locales.getCaption('pause', 'audioRecorder');//'Stop';
        titles.startRecording = locales.getCaption('startRecording', 'audioRecorder');//"Start recording here";
        titles.encoding = locales.getCaption('encoding', 'audioRecorder');//"Encoding. Please wait until it's finished";
        titles.uploading = locales.getCaption('uploading', 'audioRecorder');//'Uploading file';
        titles.recording = locales.getCaption('recording', 'audioRecorder');//'Recording';
        titles.microphone = locales.getCaption('microphone', 'audioRecorder');//'Microphone';
        titles.length = locales.getCaption('length', 'audioRecorder');//'Length';
        titles.time = locales.getCaption('time', 'audioRecorder');//'Time';
        titles.cancel = locales.getCaption('cancel', 'audioRecorder');//'Cancel';
        titles.save = locales.getCaption('save', 'audioRecorder');//'Save';
        titles.savingError = locales.getCaption('save', 'savingError');//'Something went wrong with the audio storing. Please try again!';

        return titles;
    },
    /**************************** Playing sequence ***************************/
    startPlayingSequence() {
        if (audioToolUtils.isAudioTool())
            return;

        if (playController.isAudioEditorMode()) {
            // this.playPauseForRecording(true); // removed for CART-1370 ... poor recording in advanced mode
        } else
            this.startPlayingVideo();
    },
    stopPlayingSequence() {
        if (audioToolUtils.isAudioTool())
            return;

        if (playController.isAudioEditorMode()) {
            // this.playPauseForRecording(false); // removed for CART-1370 ... poor recording in advanced mode
        } else
            this.stopPlayingVideo();
    },
    playPauseForRecording(play = true) {
        if (play) {
            playController.getOldScrollPosition();
            playController.play(false, true);
            this.changePlayState(true);
        } else {
            playController.pause(true); // should update scroll position
            this.changePlayState(false);
        }
    },
    changePlayState(value) {
        if (playController.changePlayState)
            playController.changePlayState(value);
    },
    startPlayingVideo() {
        if (this.isVideoVisible()) {
            videoUtils.playVideoPreview();
            this.changePlayState(true);
        } else {
            if (this.isVideoShapes()) {
                videoUtils.playVideoShapesPreview(true);
                this.changePlayState(true);
            }
        }
    },
    stopPlayingVideo() {
        if (this.isVideoVisible()) {
            videoUtils.pauseVideoPreview(true);
            this.changePlayState(false);
        } else {
            if (this.isVideoShapes()) {
                videoUtils.pauseVideoShapesPreview(true);
                this.changePlayState(false);
            }
        }
    },
    isVideoVisible() {
        return videoUtils.isVideoBackground();
    },
    isVideoShapes() {
        return videoUtils.isVideoShapes();
    },
    /**************************************************************************/
    onDragStart(e) {
        this.setState({
            initialX: this.state.currentX,
            initialY: this.state.currentY
        });
    },
    onDragMove(e, coreEvent) {
        this.setState({
            currentX: this.state.initialX + coreEvent.lastX,
            currentY: this.state.initialY + coreEvent.lastY,
        });
    },
    /**************************************************************************/
    getTitleInputAriaLabel() {
        var view = this.refs.title;

        if (view)
            return view.value;
        else
            return recordingUtils.getSoundTitle();
    },
    onChangeText() {
        this.forceUpdate();
    },
    render() {
        var visible = 'none';

        if (this.props.showRecorder)
            visible = 'block';
        else
            return (<div/>);

        const titles = this.getTitles();
        const menuStyle = {
            position: 'absolute',
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            left: 0,
            display: visible,
            userSelect: 'none',
            cursor: 'default',
            zIndex: 20000
        };

        const backgroundStyle = {
            position: 'absolute',
            width: menuStyle.width,
            height: menuStyle.height,
            background: '#434343',
            top: 0,
            left: 0,
            userSelect: 'none',
            cursor: 'default',
            opacity: 0.4
        };

        const width = 460;
        const height = 195;
        const padding = 20;
        const color = '#535248';
        var fillColor;

        const areaStyle = {
            position: 'absolute',
            width,
            height,
            background: 'white',
            top: this.state.currentY,
            left: this.state.currentX,
            borderRadius: 4
        };

        const titleStyle = {
            position: 'absolute',
            left: padding,
            top: padding,
            fontSize: 24,
            width: areaStyle.width - 2 * padding,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            color
        };

        if (this.state.isStartOver)
            fillColor = '#f5f5f5';
        else
            fillColor = '#f0f0ec';

        const startRecording = {
            position: 'absolute',
            width: 70,
            height: 70,
            background: fillColor,
            top: 65,
            left: padding,
            borderColor: '#a3a393',
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 4,
            cursor: 'pointer',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        var recordTitleStyle = {
            position: 'absolute',
            left: 0,
            bottom: 8,
            fontSize: 12,
            width: startRecording.width,
            textAlign: 'center',
            display: 'inline-block',
            color: '#d11010'
        };

        var recordIconStyle = {
            position: 'absolute',
            top: 10,
            left: 25,
            width: 19,
            height: 34
        };

        var arrowStyle = {
            position: 'absolute',
            top: startRecording.top + 30,
            left: startRecording.left + startRecording.width + 20,
            width: 34,
            height: 12
        };

        var messageStyle = {
            position: 'absolute',
            left: arrowStyle.left + arrowStyle.width + 5,
            top: arrowStyle.top - 4,
            fontSize: 18,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            cursor: 'default',
            color
        };

        if (this.state.isCancelOver)
            fillColor = '#f5f5f5';
        else
            fillColor = '#f0f0ec';

        const cancelButtonStyle = {
            position: 'absolute',
            backgroundColor: fillColor,
            width: 100,
            height: 22,
            paddingTop: 6,
            bottom: padding,
            right: padding,
            color: '#4c4c4c',
            fontSize: 14,
            textAlign: 'center',
            borderRadius: 4,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#d6d6d6',
            cursor: 'pointer',
            margin: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            boxSizing: 'initial',
            display: 'grid'
        };

        var saveButton;
        var leftPos = startRecording.left + startRecording.width + 10;
        var microphoneHolder = {
            position: 'absolute',
            top: startRecording.top,
            left: leftPos,
            width: areaStyle.width - padding - leftPos,
            height: startRecording.height,
            display: 'none'
        };

        var leftSideStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: 100,
            height: microphoneHolder.height
        };

        var micTitleStyle =  {
            position: 'absolute',
            left: 0,
            top: 5,
            width: leftSideStyle.width,
            fontSize: 16,
            cursor: 'default',
            color,
            textAlign: 'right'
        };

        var durationTitleStyle =  {
            position: 'absolute',
            left: 0,
            bottom: 5,
            width: leftSideStyle.width,
            fontSize: 16,
            cursor: 'default',
            color,
            textAlign: 'right'
        };

        var middleGap = 10;
        var rightSideStyle = {
            position: 'absolute',
            top: 0,
            left: leftSideStyle.width + middleGap,
            width: microphoneHolder.width - leftSideStyle.width - middleGap,
            height: microphoneHolder.height
        };

        var timeStyle =  {
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: rightSideStyle.width,
            fontSize: 26,
            cursor: 'default',
            color: '#a5a797',
            textAlign: 'left'
        };

        var microphoneLevelsElement;
        var arrowHolder;
        var encoderMessageHolder;
        var recordintTitle;
        var recordingIcon;
        var durationText = '00:00:00:000';
        var microphoneText = titles.microphone + ':';
        var timeText = titles.time + ':';

        switch(this.state.currentState) {
            case 0: { // Start recording
                recordingIcon = appParameters.RESOURCES_LOCATION() + 'assets/recorder/record-icon.png';
                recordintTitle = titles.record;

                arrowHolder = <div>
                    <img alt='' aria-hidden='true' style={arrowStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/recorder/record-arrow.png'}/>
                    <span style={messageStyle}>{titles.startRecording}</span>
                </div>;

                break;
            }

            case 1: { // Stop recording
                recordingIcon = appParameters.RESOURCES_LOCATION() + 'assets/recorder/record-stop.png';
                recordintTitle = titles.stop;
                recordIconStyle.width = 26;
                recordIconStyle.height = 26;
                recordIconStyle.left = 22;
                recordIconStyle.top = 18;
                recordTitleStyle.color = '#535248';
                arrowStyle.display = 'none';
                messageStyle.display = 'none';
                microphoneHolder.display = 'block';

                var levelStyle =  {
                    position: 'absolute',
                    left: 0,
                    top: 10,
                    width: rightSideStyle.width,
                    height: 8,
                    cursor: 'default',
                    background: 'white',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#dfe0d4'
                };

                var levels = [];
                var sliceWidth = (rightSideStyle.width - 11) / 10;

                for (var i=0; i<10; i++) {
                    var levelElementStyle = {
                        position: 'absolute',
                        left: i * (sliceWidth + 1) + 1,
                        top: 1,
                        width: sliceWidth,
                        height: 6,
                        cursor: 'default',
                        background: '#dfe0d4'
                    };
                    var levelElement = <div ref={'level_' + i} style={levelElementStyle} key={i}/>;

                    levels.push(levelElement);
                }

                microphoneLevelsElement = <div style={levelStyle}>{levels}</div>;

                break;
            }

            case 3: { // Play/Pause sound
                microphoneText = titles.recording + ':';
                timeText = titles.length + ':';
                durationText = this.state.duration;
                microphoneHolder.display = 'block';
                recordingIcon = appParameters.RESOURCES_LOCATION() + 'assets/recorder/record-icon.png';
                recordintTitle = titles.record;

                const titleStyle = {
                    width: rightSideStyle.width,
                    height: 27,
                    background: 'white',
                    borderRadius: 4,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    borderColor: '#a3a393',
                    borderWidth: 1,
                    borderStyle: 'solid',
                    alignItems: 'center'
                };
                const inputStyle = {
                    position: 'absolute',
                    color: '#535248',
                    top: 6,
                    paddingLeft: 5,
                    fontSize: 12,
                    width: titleStyle.width - 65,
                    resize: 'none',
                    overflow: 'hidden',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent'
                };

                if (this.state.isPlayOver)
                    fillColor = '#f5f5f5';
                else
                    fillColor = '#f0f0ec';

                const playButtonStyle = {
                    position: 'absolute',
                    backgroundColor: fillColor,
                    width: 64,
                    height: 23,
                    right: 1,
                    top: 1,
                    color: '#535248',
                    borderRadius: '2px 4px 4px 2px',
                    fontSize: 14,
                    textAlign: 'center',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#a3a393',
                    cursor: 'pointer',
                    margin: 0,
                    padding: 0,
                    boxSizing: 'initial',
                    display: 'grid'
                };

                var icon = 'fa fa-play';
                var playBtnText = titles.play;

                if (this.state.isPlaying) {
                    icon = 'fa fa-pause';
                    playBtnText = titles.pause;
                }

                var playIconStyle = {
                    position: 'absolute',
                    top: 5,
                    left: 5,
                    color: '#535248'
                };

                var spanStyle = {
                    position: 'absolute',
                    top: 5,
                    left: 17,
                    color: '#535248',
                    fontSize: 13,
                    width: playButtonStyle.width - 17,
                    textAlign: 'center'
                };

                if (playBtnText && playBtnText.length > 6) {
                    spanStyle.fontSize = 10;
                    spanStyle.top = 6;
                }

                const fillOutFieldViewWidth = 150;
                const fillOutFieldViewStyle = {
                    position: 'absolute',
                    background: '#434343',
                    width: fillOutFieldViewWidth,
                    height: 30,
                    top: 38,
                    left: 6,
                    borderRadius: 5,
                    zIndex: 99999,
                    pointerEvents: 'none'
                };

                const stemStyle = {
                    position: 'absolute',
                    borderWidth: 10,
                    borderStyle: 'solid',
                    borderBottomColor: '#434343',
                    borderTopColor: 'transparent',
                    borderLeftColor: 'transparent',
                    borderRightColor: 'transparent',
                    top: -20,
                    left: fillOutFieldViewWidth/2 - 10
                };

                const captionStyle = {
                    position: 'absolute',
                    color: 'white',
                    wordWrap: 'break-word',
                    textAlign: 'center',
                    fontSize: 12,
                    left: 5,
                    top: 8,
                    width: fillOutFieldViewWidth - 10
                };

                var fillOutFieldView;
                var isDisabled = false;

                if (this.refs.title && this.refs.title.value.length < 1) {
                    fillOutFieldView =
                        <div style={fillOutFieldViewStyle}>
                            <div style={stemStyle}></div>
                            <div style={captionStyle}>
                                Please fill out this field!
                            </div>
                        </div>;

                    isDisabled = true;
                }

                microphoneLevelsElement =
                    <div style={titleStyle}>
                        <input type='text' aria-label={this.getTitleInputAriaLabel()} ref='title' className='titleInput' style={inputStyle} defaultValue={recordingUtils.getSoundTitle()} onChange={this.onChangeText} spellCheck='true' autoCorrect='off' autoCapitalize='off' autoComplete='off'/>
                        {fillOutFieldView}

                        <button aria-label={playBtnText} style={playButtonStyle} onMouseOver={this.onPlayMouseIn} onMouseOut={this.onPlayMouseOut} onTouchEnd={this.onPlayClick} onClick={this.onPlayClick}>
                            <i style={playIconStyle} className={icon}></i>
                            <span style={spanStyle}>{playBtnText}</span>
                        </button>
                    </div>;

                if (this.state.isSaveOver)
                    fillColor = '#8a8a8a';
                else
                    fillColor = '#6e6e6e';

                var saveButtonStyle = {
                    position: 'absolute',
                    backgroundColor: fillColor,
                    width: 100,
                    height: 22,
                    paddingTop: 6,
                    bottom: padding,
                    right: padding + cancelButtonStyle.width + 10,
                    color: 'white',
                    fontSize: 14,
                    textAlign: 'center',
                    borderRadius: 4,
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#4d4d4d',
                    boxShadow: 'inset 0 1px 0 #dbdbdb',
                    cursor: 'pointer',
                    margin: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                    boxSizing: 'initial',
                    display: 'grid'
                };

                var tabIndexValue = '';

                if (isDisabled) {
                    saveButtonStyle.opacity = 0.5;
                    saveButtonStyle.pointerEvents = 'none';
                    tabIndexValue = '-1';
                }

                saveButton = <button tabIndex={tabIndexValue} aria-label={titles.save} style={saveButtonStyle} onMouseOver={this.onSaveMouseIn} onMouseOut={this.onSaveMouseOut} onTouchEnd={this.onSaveClick} onClick={this.onSaveClick}>{titles.save}</button>;
                break;
            }

            case 2: // Encoding
            case 4: // Uploading
            case 5: { // Storing error
                var encoderMessageHolderStyle = {
                    position: 'absolute',
                    top: 75,
                    left: padding,
                    width: areaStyle.width - 2 * padding,
                    height: 30
                };

                var loaderStyle = {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    color
                };

                var encodinTitleStyle = {
                    position: 'absolute',
                    left: 70,
                    top: 14,
                    fontSize: 18,
                    width: encoderMessageHolderStyle.width - 70,
                    textAlign: 'left',
                    display: 'inline-block',
                    color
                };

                var alertTitle = titles.encoding;

                if (this.state.currentState == 4)
                    alertTitle = titles.uploading;
                else if (this.state.currentState == 5) {
                    alertTitle = titles.savingError;
                    encodinTitleStyle.top = 3;
                }

                encoderMessageHolder = <div style={encoderMessageHolderStyle}>
                    <i style={loaderStyle} className='fa fa-spinner fa-pulse fa-3x'/>
                    <span style={encodinTitleStyle}>{alertTitle}</span>
                </div>

                startRecording.display = 'none';
                break;
            }
        }

        return (
            <div style={menuStyle} id="recordingPopup">
                <audio ref='audioElement' preload='auto' playsInline onEnded={this.onAudioEnded}/>
                <div style={backgroundStyle}></div>
                <Draggable axis='none' position={{x:0, y:0}} onStart={this.onDragStart} onDrag={this.onDragMove} onStop={this.onDragMove}>
                    <div style={areaStyle}>
                        <span style={titleStyle}>{titles.popupTitle}</span>
                        <button id="recordingFirstFocusableElement" aria-label={recordintTitle} style={startRecording} onMouseOver={this.onStartMouseIn} onMouseOut={this.onStartMouseOut} onTouchEnd={this.onStartClick} onClick={this.onStartClick}>
                            <img alt='' aria-hidden='true' style={recordIconStyle} src={recordingIcon}/>
                            <span style={recordTitleStyle}>{recordintTitle}</span>
                        </button>
                        {arrowHolder}
                        {encoderMessageHolder}
                        <div style={microphoneHolder}>
                            <div style={leftSideStyle}>
                                <span style={micTitleStyle}>{microphoneText}</span>
                                <span style={durationTitleStyle}>{timeText}</span>
                            </div>
                            <div style={rightSideStyle}>
                                {microphoneLevelsElement}
                                <span ref='duration' style={timeStyle}>{durationText}</span>
                            </div>
                        </div>
                        {saveButton}
                        <button id="recordingLastFocusableElement" aria-label={titles.cancel} style={cancelButtonStyle} onMouseOver={this.onCancelMouseIn} onMouseOut={this.onCancelMouseOut} onTouchEnd={this.onCancelClick} onClick={this.onCancelClick}>{titles.cancel}</button>
                    </div>
                </Draggable>;
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const showRecorder = state.menu.showRecorder;

    return {
        showRecorder
    };
}

export const RecorderPopup = connect(mapStateToProps)(RecorderPopupContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/RecorderPopup.js
 **/